import AppContext from '../../../AppContext';
import { formattedTs, MardownText } from '../utils';
import { useEffect, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBotResponse, toggleProgress } from '../../Messages/messageSlice';

export const TextMessage = ({
  text,
  startsSequence,
  endsSequence,
  showBotAvatar,
  ts,
  humanAvatar
}) => {
  const { notification } = useSelector((state) => state.widgetState);
  const progress = useSelector((state) => state.messageState.progress);
  const audioPlayer = useRef(null);
  const dispatch = useDispatch();

  const theme = useContext(AppContext);
  const {
    userId,
    rasaServerUrl,
    botAvatar,
    botMsgColor,
    botMsgBackgroundColor
  } = theme;
  useEffect(() => {
    const handlePlay = () => {
      if (audioPlayer.current) {
        audioPlayer.current
          .play()
          .catch((error) => console.error('Play error:', error));
      }
    };

    if (notification) {
      audioPlayer.current.addEventListener('loadeddata', handlePlay);
    }

    return () => {
      if (audioPlayer.current) {
        audioPlayer.current.removeEventListener('loadeddata', handlePlay);
      }
    };
  }, [notification]);

  useEffect(() => {
    if (
      progress === 'booking' &&
      text.includes(
        "Unfortunately I'm experiencing a problem with your request🙁. Please try again later or refresh and restart this chat."
      )
    ) {
      dispatch(
        fetchBotResponse({
          rasaServerUrl,
          message: '/fail',
          sender: userId,
          metadata: {}
        })
      );
      dispatch(toggleProgress(''));
    }
  }, [text]);

  const position = [
    'message',
    `${startsSequence ? 'start' : ''}`,
    `${endsSequence ? 'end' : ''}`
  ]
    .join(' ')
    .trim();
  let borderStyle;
  if (position === 'message start end') {
    borderStyle =
      'rounded-tl-[14px] rounded-br-[14px] rounded-tr-[14px] rounded-bl-[5px]';
  }

  if (position === 'message start') {
    borderStyle =
      'rounded-tl-[14px] rounded-br-[14px] rounded-tr-[14px] rounded-bl-[5px]';
  }

  if (position === 'message  end') {
    borderStyle =
      'rounded-tl-[5px] rounded-br-[14px] rounded-tr-[14px] rounded-bl-[5px]';
  }
  if (position === 'message') {
    borderStyle =
      'rounded-tl-[5px] rounded-bl-[5px] rounded-br-[14px] rounded-tr-[14px]';
  }

  return (
    <div className="flex space-x-1">
      <div className={`flex w-5 items-end`}>
        <img
          className={`${showBotAvatar ? 'w-5' : 'hidden w-2'}`}
          src={humanAvatar ? humanAvatar : botAvatar}
          alt="Bot Logo"
        />
      </div>
      <div className="min-w-[88px] max-w-[80%] space-x-1">
        <div
          className={`antialiased ${borderStyle} whitespace-pre-line break-words py-[8px] px-[15px] text-sm`}
          style={{
            color: botMsgColor,
            backgroundColor: botMsgBackgroundColor
          }}
          dir="auto"
        >
          <MardownText text={text} />
        </div>
        {showBotAvatar && (
          <div className="text-[10px] italic text-gray-500 antialiased">
            {formattedTs(ts)}
          </div>
        )}
      </div>
      <audio
        ref={audioPlayer}
        src={
          'https://scoutfroneasset.blob.core.windows.net/frontend-asset/Notification.mp3'
        }
      />
    </div>
  );
};
